module.exports = __webpack_public_path__ + "img/daily_logoH.a301b397.png";